import { PlusIcon } from '../Icons/Icons'

export function ShopCard ({ name, mount, form, shop, setShop, ID, inven, setInven }) {
  const AddIng = () => {
    const newShop = []
    const newInven = inven
    shop.forEach(element => {
      if (element.id !== ID) {
        newShop.push(element)
      } else {
        newInven.push(element)
      }
    })

    setShop(newShop)
    setInven(newInven)
  }

  return (
    <section className='flex w-full min-h-16 justify-between items-center bg-[#313131] border-2 border-[#434343] rounded-xl'>
              <div className='flex gap-5 w-5/6 items-center'>
              <img className='h-16 rounded-[0.50rem]' src="./LogoP.png" alt="" />
                <h6 className='max-[1280px]:text-xl font-semibold text-[#E3E3E3] w-full'>{ name }</h6>
              </div>

              <button onClick={AddIng} className='w-8 h-8 rounded-full bg-orangse-600 border-[#575757] mr-2.5 text-3sxl flex justify-center items-center'><PlusIcon/></button>
            </section>
  )
}
